/**
 * Accesses the given permissions object by the given permissionPath in the form of e.g.
 * `customRegistrationForm.enrollment` and returns the associated Crud permission
 *
 * @param permissions the stat permission object
 * @param permissionPath the path leading to the crud permissions to be resolved
 * @returns the crud permissions in the given path
 */
export function resolvePermissionPath(permissions, permissionPath) {
    return permissionPath.split('.').reduce((prev, curr) => prev === null || prev === void 0 ? void 0 : prev[curr], permissions);
}
